import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import EmptyStates from '../../../common/components/empty-states';

const NoPosts: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EmptyStates
      title={t('no-posts.posts-coming-soon')}
      content={t('no-posts.explore-other-categories')}
    />
  );
};

export default NoPosts;
